module.exports = __webpack_public_path__ + "static/img/IMG_20170101_000635.41042764.jpg";